import { render, staticRenderFns } from "./SetupDesktop.vue?vue&type=template&id=79609034&scoped=true&"
import script from "./SetupDesktop.vue?vue&type=script&lang=js&"
export * from "./SetupDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SetupDesktop.vue?vue&type=style&index=0&id=79609034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79609034",
  null
  
)

export default component.exports